import { TableConfig } from '@shared/interfaces/table/table-config';
import { MeterDto } from '@app/api/dmc';

export const meterTableConfig: TableConfig<MeterDto> = {
  selectable: true,
  selectableType: 'single',
  columns: [
    {
      title: 'meter.serialNumber',
      key: 'serialNumber',
    },
    {
      title: 'meter.meterNumber',
      key: 'meterNumber'
    }
  ]
};
